import { Text, VStack, StackProps } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../../i18n';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import { FlowsQuestionGroup } from '../../../../../types/FlowsTypes';
import { parseStringForAnswers } from '../../../../../utils/stringUtils';
import { getHTMLIdForGroup } from '../../utils/helperFunctions';

interface Props {
  group: FlowsQuestionGroup;
}

const QuestionGroupHeader: React.FC<
  React.PropsWithChildren<Props & StackProps>
> = ({ group, ...props }) => {
  const answers = useFlowsSelector((state) => state.flows.answers);

  return (
    <VStack
      align="stretch"
      id={getHTMLIdForGroup(group)}
      pt="4"
      px={'10'}
      {...props}
    >
      <Text textStyle="largeBodyBold">
        {parseStringForAnswers({
          answers,
          question: handleResponseLanguage(group.title),
          index: group.index,
        })}
      </Text>
      <Text color="text.gray">
        {parseStringForAnswers({
          answers,
          question: handleResponseLanguage(group.description),
          index: group.index,
        })}
      </Text>
    </VStack>
  );
};

export default QuestionGroupHeader;
